/* tslint:disable */

declare var Object: any;
export interface TeodempcompanyInterface {
  "empId": string;
  "companyId": number;
  "empNo": string;
  "startDate": Date;
  "endDate"?: Date;
  "status"?: number;
  "gradeCode": string;
  "employCode": string;
  "costCode": string;
  "isMain": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "workLocationCode"?: string;
  "jobStatusCode"?: string;
  "reportTo"?: string;
  "employmentEnddate"?: Date;
  "employmentStartdate"?: Date;
  "reportOrder"?: number;
  "positionId": number;
  rel_company?: any;
  rel_personal?: any;
  rel_position?: any;
}

export class Teodempcompany implements TeodempcompanyInterface {
  "empId": string;
  "companyId": number;
  "empNo": string;
  "startDate": Date;
  "endDate": Date;
  "status": number;
  "gradeCode": string;
  "employCode": string;
  "costCode": string;
  "isMain": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "workLocationCode": string;
  "jobStatusCode": string;
  "reportTo": string;
  "employmentEnddate": Date;
  "employmentStartdate": Date;
  "reportOrder": number;
  "positionId": number;
  rel_company: any;
  rel_personal: any;
  rel_position: any;
  constructor(data?: TeodempcompanyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodempcompany`.
   */
  public static getModelName() {
    return "Teodempcompany";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodempcompany for dynamic purposes.
  **/
  public static factory(data: TeodempcompanyInterface): Teodempcompany{
    return new Teodempcompany(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodempcompany',
      plural: 'Teodempcompanies',
      path: 'Teodempcompanies',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "empNo": {
          name: 'empNo',
          type: 'string'
        },
        "startDate": {
          name: 'startDate',
          type: 'Date'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "gradeCode": {
          name: 'gradeCode',
          type: 'string'
        },
        "employCode": {
          name: 'employCode',
          type: 'string'
        },
        "costCode": {
          name: 'costCode',
          type: 'string'
        },
        "isMain": {
          name: 'isMain',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "workLocationCode": {
          name: 'workLocationCode',
          type: 'string'
        },
        "jobStatusCode": {
          name: 'jobStatusCode',
          type: 'string'
        },
        "reportTo": {
          name: 'reportTo',
          type: 'string'
        },
        "employmentEnddate": {
          name: 'employmentEnddate',
          type: 'Date'
        },
        "employmentStartdate": {
          name: 'employmentStartdate',
          type: 'Date'
        },
        "reportOrder": {
          name: 'reportOrder',
          type: 'number'
        },
        "positionId": {
          name: 'positionId',
          type: 'number'
        },
      },
      relations: {
        rel_company: {
          name: 'rel_company',
          type: 'any',
          model: ''
        },
        rel_personal: {
          name: 'rel_personal',
          type: 'any',
          model: ''
        },
        rel_position: {
          name: 'rel_position',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodempcompany.ts